export default __webpack_public_path__ + "static/media/nba-logo.1592f78b.png";